import React from 'react';
import LinkedThreadButton from '../../linked-threads/LinkedThreadButton';
import { ReactComponent as ConversationsIcon } from '../../../../icons/nav-links/conversations.svg';

interface ComponentLinkedThreadProps {
  componentName: string;
  match: any;
  agentId?: string;
  className?: string;
  children: React.ReactNode;
  label?: string;
}

// List of component types that support linked threads
const LINKED_THREAD_SUPPORTED_COMPONENTS = ['Email'];

const ComponentLinkedThread: React.FC<ComponentLinkedThreadProps> = ({
  componentName,
  match,
  agentId,
  className,
  children,
  label,
}) => {
  // Check if this component type supports linked threads
  const supportsLinkedThreads =
    LINKED_THREAD_SUPPORTED_COMPONENTS.includes(componentName);

  if (supportsLinkedThreads) {
    return (
      <LinkedThreadButton
        componentName={componentName}
        match={match}
        agentId={agentId || ''}
        className={className}
        content={
          label ? (
            <span>
              <ConversationsIcon /> {label}
            </span>
          ) : (
            <ConversationsIcon />
          )
        }
      />
    );
  }

  // For unsupported components, just render the children
  return <>{children}</>;
};

export default ComponentLinkedThread;
